import classNames from "classnames/bind";
import styles from "./Checkbox.module.sass";

interface CheckboxProps {
  neutral?: boolean;
  isChecked?: boolean;
  handleChange?: () => void;
}

export const Checkbox = ({ neutral = false, isChecked = false, onChange = () => {} }) => {
  const cx = classNames.bind(styles);

  const handleChange = () => {
    onChange();
  };

  const checkboxStyles = cx("Checkbox", {
    Neutral: neutral,
  });

  return (
    <label className={checkboxStyles}>
      <input type="checkbox" checked={isChecked} onChange={handleChange} />
      <span className={styles.Checkmark}></span>
    </label>
  );
};
